import React, { useEffect, useRef } from 'react'
import { Global } from '@emotion/react'
import TreeSelect from 'rc-tree-select'
import clsx from 'clsx'
import { useTheme } from '@ow/theme'
import { styles } from './styled'
import CloseWrapper from '../close-wrapper'

const Cas = function ({
  tree = [],
  inputStyle = {},
  onChange,
  fieldNames = {
    label: 'title',
    value: 'objectId',
    children: 'children',
  },
  multiple = false, // 是否支持多选
  showSearch = true, // 是否支持搜索
  allowClear = true, // 是否显示删除按钮
  checkable = false,
  selectLeaf,
  bubble,
  onSelect,
  value: finalValue,
  ...props
}) {
  const nodeMapRef = useRef({})
  const { themeClass } = useTheme()
  const { value, children, label } = fieldNames
  const dealChildren = (arr) => {
    if (arr && arr.forEach) {
      arr.forEach((e) => {
        nodeMapRef.current[e[value]] = e
        if (e && e[children] && e[children].length === 0) {
          e[children] = null
        } else {
          dealChildren(e[children])
        }
      })
    }
  }

  // 合并子节点为父节点，压缩请求的筛选条件长度
  const bubbling = (ids) => {
    const queue = [...ids]
    const counter = {}
    const setCounter = (parent, id) => {
      if (counter[parent]) {
        counter[parent].push(id)
      } else {
        counter[parent] = [id]
      }
    }

    const checkCounter = (id) => {
      if (counter[id].length === nodeMapRef.current[id].children.length) {
        queue.unshift(id)
        delete counter[id]
      }
    }

    while (queue.length) {
      const id = queue.pop()
      const { parentId } = nodeMapRef.current[id]

      setCounter(parentId, id)
      if (parentId) {
        checkCounter(parentId)
      }
    }

    return Object.keys(counter)
      .map((id) => counter[id])
      .flat(1)
  }

  useEffect(() => {
    dealChildren(tree || [])
    // console.log('组件内部接受到的tree数据', JSON.parse(JSON.stringify(tree)))
  }, [tree])
  const onClear = () => {
    if (multiple) {
      onChange([], [], {}, [])
    } else {
      onChange('')
    }
  }
  return (
    <>
      <Global styles={styles} />
      <CloseWrapper allowClear={allowClear} onClear={onClear} hasDropdown>
        <TreeSelect
          dropdownClassName={clsx(themeClass)}
          transitionName="rc-tree-select-dropdown-slide-up"
          choiceTransitionName="rc-tree-select-selection__choice-zoom"
          treeData={tree}
          style={inputStyle}
          multiple={multiple}
          showSearch={showSearch}
          treeCheckable={checkable}
          showCheckedStrategy={
            checkable ? TreeSelect.SHOW_ALL : TreeSelect.SHOW_CHILD
          }
          treeNodeFilterProp={label}
          onSelect={(val, node) => {
            if (onSelect) {
              onSelect(val, node)
            }
          }}
          onChange={(e, a, b) => {
            console.log('filter->>', e, a, b)
            const v = Array.isArray(e) && bubble ? bubbling(e) : e
            const dealEle =
              e && typeof e !== 'string' && typeof e !== 'number'
                ? v.map((item) => nodeMapRef.current[item])
                : nodeMapRef.current[e]

            if (onChange) {
              onChange(v, a, b, v ? dealEle : undefined)
            }
          }}
          fieldNames={fieldNames}
          value={finalValue}
          inputIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon-chevron-down"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="#bfbfbf"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M6 9l6 6l6 -6" />
            </svg>
          }
          {...props}
        />
      </CloseWrapper>
    </>
  )
}

export default Cas
